/**
 * BaseModel
 */
export default class BaseModel {

    constructor() {
        this.className = this.constructor.name;

    }

    getClassName() {
        return this.className;
    }
}